(function () {
  // ===== AYARLAR =====
  const BONUS_VARIANT_ID = 47482996588693;
  const TRIGGER_TAG = 'tul_perde';
  const REQUIRED_QTY = 2;
  const BONUS_QTY = 1;
  const MSG_PROGRESS = 'Bir tül perde daha ekle, hediyeni kazan!';
  const MSG_EARNED = 'Tebrikler, hediyeni kazandın!';
  const DEBUG = true;
  // ===================

  let working = false;
  function log(...a) { if (DEBUG) console.log('[tul-perde]', ...a); }
  log('script yuklendi');

  function readCartFromDOM() {
    const items = [...document.querySelectorAll('.cart-item[data-variant-id]')];
    let tulCount = 0;
    let bonusEl = null;
    items.forEach((li) => {
      const variantId = parseInt(li.dataset.variantId, 10);
      const qty = parseInt(li.dataset.quantity || '1', 10);
      const tags = (li.dataset.tags || '').toLowerCase();
      if (variantId === BONUS_VARIANT_ID) { bonusEl = li; return; }
      if (tags.split(',').map(t => t.trim()).includes(TRIGGER_TAG.toLowerCase())) {
        tulCount += qty;
      }
    });
    return { tulCount, bonusEl, itemCount: items.length };
  }

  function addBonus() {
    log('hediye ekleniyor...');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: BONUS_VARIANT_ID, quantity: BONUS_QTY }] }),
    }).then(r => r.json());
  }

  // Hediyeyi sepetten cikar
  function removeBonus(bonusEl) {
    log('hediye cikariliyor...');
    let key = null;
    const removeLink = bonusEl.querySelector('a[href*="/cart/change"], a[href*="?id="], .btn-remove');
    if (removeLink && removeLink.getAttribute('href')) {
      const m = removeLink.getAttribute('href').match(/[?&]id=([^&]+)/);
      if (m) key = decodeURIComponent(m[1]);
    }
    const body = key ? { id: key, quantity: 0 } : { id: BONUS_VARIANT_ID, quantity: 0 };
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(r => r.json());
  }

  function renderMessage(tulCount) {
    const el = document.getElementById('TulPerdeGiftMessage');
    if (!el) return;
    if (tulCount <= 0) { el.style.display = 'none'; return; }

    const earned = tulCount >= REQUIRED_QTY;
    const pct = Math.min(100, Math.round((tulCount / REQUIRED_QTY) * 100));
    const giftIcon = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

    el.innerHTML =
      '<div class="tpg-icon' + (earned ? ' tpg-earned' : '') + '">' + giftIcon + '</div>' +
      '<div class="tpg-body">' +
        '<div class="tpg-text">' + (earned ? MSG_EARNED : MSG_PROGRESS) + '</div>' +
        '<div class="tpg-bar"><span style="width:' + pct + '%"></span></div>' +
      '</div>';
    el.className = 'tul-perde-gift-msg' + (earned ? ' is-earned' : '');
    el.style.display = 'flex';
  }

  function refreshCartUI() {
    // Temanin bilinen sepet guncelleme event'lerini tetikle
    ['cart:refresh', 'cart:updated', 'cart:build', 'theme:cart:change'].forEach((name) => {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });

    const drawer = document.querySelector('cart-drawer');

    // 1) Drawer'in kendi render metodu varsa kullan
    if (drawer && typeof drawer.renderContents === 'function') {
      fetch('/cart.js').then(r => r.json()).then(c => {
        drawer.renderContents({ sections: null, cart: c });
        log('drawer renderContents ile guncellendi');
      }).catch(() => {});
      return;
    }

    // 2) Section render API ile drawer icerigini yeniden cek (reload'suz)
    const sectionId = drawer && drawer.dataset.sectionId;
    if (sectionId) {
      fetch('/?sections=' + sectionId).then(r => r.json()).then((data) => {
        const html = data[sectionId];
        if (!html) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const fresh = tmp.querySelector('#CartDrawer-' + sectionId);
        const current = document.getElementById('CartDrawer-' + sectionId);
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          log('drawer section render ile guncellendi');
        }
      }).catch((e) => log('section render hatasi:', e));
      return;
    }

    log('drawer guncellenemedi (reload yapilmadi)');
  }

  async function check() {
    if (working) return;
    working = true;
    try {
      const { tulCount, bonusEl } = readCartFromDOM();
      log('tul_perde adedi:', tulCount, '| hediye sepette:', !!bonusEl);

      // mesaj her zaman gercek tul perde sayisina gore
      renderMessage(tulCount);

      if (tulCount >= REQUIRED_QTY && !bonusEl) {
        await addBonus();
        refreshCartUI();
      }
      // Otomatik kaldirma iptal edildi: tul perde sayisi dusse bile hediye sepette kalir.
    } catch (e) {
      console.warn('[tul-perde] hata:', e);
    } finally {
      working = false;
    }
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.__tulPerdeTimer);
    window.__tulPerdeTimer = setTimeout(check, 350);
  });

  function startObserving() {
    const drawer = document.querySelector('cart-drawer') || document.body;
    observer.observe(drawer, { childList: true, subtree: true });
    log('observer baslatildi');
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();